import axios from "axios";
import { SET_ERROR, APAR_SETUP, UKG_INVOICES, UKG_INVOICE, APAR_REPORT } from "../../types";
import ToastMessage from "../../../components/toast";

export const getAPARSettings = (payload) => {
    return async dispatch => {
        let res = await axios.get('api/apar-comparison/get-setup').catch(err => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    err, error: true
                }
            });
        });
        return dispatch({ type: APAR_SETUP, payload: (res.data || []) });
    }
};

export const postAPARSettings = (payload) => {
    return async dispatch => {
        await axios.post('api/apar-comparison/add-update-setup', payload).catch(er => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    er, error: true
                }
            });
            ToastMessage("Error uploading APAR settings", "error");
        });
        return getAPARSettings();
    };
};

export const getUKGInvoices = (params) => {
    return async dispatch => {
        let res = await axios.get('api/apar-comparison/ukg-invoices', { params }).catch(err => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    err, error: true
                }
            });
        });
        return dispatch({ type: UKG_INVOICES, payload: (res.data || []) });
    };
};
export const uploadUKGInvoice = (payload) => {
    return async dispatch => {
        let res = await axios.post('api/file-transform/upload-ukg-invoice', payload).catch(err => {
            ToastMessage("Error uploading UKG invoice", "error");
            return dispatch({
                type: SET_ERROR,
                payload: {
                    err, error: true
                }
            });
        });
        ToastMessage("UKG invoice uploaded successfully", "success");
        return dispatch({ type: UKG_INVOICE, payload: (res.data || []) });
    };
};

export const deleteUKGInvoice = (invoiceNumber) => {
    return async dispatch => {
        let res = await axios.delete(`api/apar-comparison/ukg-invoices/${invoiceNumber}`).catch(err => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    err, error: true
                }
            });
        });
        ToastMessage("UKG invoice deleted successfully", "success");
        return dispatch({ type: UKG_INVOICE, payload: (res.data || []) });
    };
};

export const updateUKGInvoice = (payload) => {
    return async dispatch => {
        let res = await axios.post('api/apar-comparison/update-ukg-invoice', payload).catch(err => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    err, error: true
                }
            });
            ToastMessage("Error updating invoice", "error");
        });
        ToastMessage("Invoice updated successfully", "success");
        return dispatch({ type: UKG_INVOICE, payload: (res.data || []) });
    };
};

export const getAPARReport = (params) => {
    return async dispatch => {
        let res = await axios.get('api/apar-comparison/apar-report', { params }).catch(err => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    err, error: true
                }
            });
        });
        return dispatch({ type: APAR_REPORT, payload: (res.data || []) });
    };
};